"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.P13NValidations = void 0;
var regular_expressions_1 = require("./regular-expressions");
exports.P13NValidations = {
    EMAIL: regular_expressions_1.emailRegex,
    HOSTNAME: regular_expressions_1.domainRegex,
    PHONE: regular_expressions_1.phoneRegex,
    GUID: regular_expressions_1.GUIDRegex,
    COLOR_HEX: regular_expressions_1.colorHexRegex,
};
/** Missing Validations for now:
 * HOSTNAME - hostname according to IANA
 * IPV4 - ip version 4 address (32bits)
 * IPV6 - ip version 6(128bits)
 * CREDIT_CARD
 * COUNTRY
 * LANGUAGE
 * URI
 * WEB_URL
 * CURRENCY
 * DECIMAL_VALUE
 */
